/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "Once the tournament exists" |
*
* @param {Tournament_Wiz_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_guide_title = /** @type {((inputs?: Tournament_Wiz_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Guide_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une fois le tournoi créé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una vez creado el torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Depois que o torneio existir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Una volta creato il torneo")
	return /** @type {LocalizedString} */ ("Once the tournament exists")
});